import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import axios from 'axios';
import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';

const App = lazy(() => import('./App'));

LicenseManager.setLicenseKey(
  'Using_this_AG_Grid_Enterprise_key_( AG-049782 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( EB )_is_granted_a_( Single Application )_Developer_License_for_the_application_( EB )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( EB )_need_to_be_licensed___( EB )_has_been_granted_a_Deployment_License_Add-on_for_( 1 )_Production_Environment___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 26 October 2024 )____[v2]_MTcyOTg5NzIwMDAwMA==6723a78d2ad0ce7337975af09a7b89a0'
);

const CONFIG_URL = `${process.env.PUBLIC_URL}/env.json`;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const getDeviceInfo = async () => {
  axios
    .get(CONFIG_URL)
    .then(res => {
      localStorage.setItem('apiUrls', JSON.stringify(res.data));
      // NextflowUI projesi mobil-wrapper projesinden çağrıldıgında bazen apiUrls u düzgün yükleyemiyor. localStorage e yazdıgına emin olmak için setInterval in içine kontrol eklendi.
      const apiUrlsInterval = setInterval(() => {
        const apiUrlsOnStorage = localStorage.getItem('apiUrls');
        if (apiUrlsOnStorage) {
          clearInterval(apiUrlsInterval);
          root.render(<Suspense fallback={<div></div>} children={<App />}></Suspense>);
        }
      }, 100);
    })
    .catch(() => {
      const errorMessage = 'Error while fetching global config, the App wil not be rendered. (This is NOT a React error.)';
      return <p style={{ color: 'red', textAlign: 'center' }}>{errorMessage}</p>;
    });
};

getDeviceInfo();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
